import React from 'react';
import { bool, func, string, object } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import arrayMutators from 'final-form-arrays';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import classNames from 'classnames';

import { propTypes } from '../../util/types';
import {
  composeValidators,
  autocompleteSearchRequired,
  autocompletePlaceSelected,
  numberOfMinimumCapacityMustBeInferiorToMaximumCapacity,
} from '../../util/validators';
import {
  Form,
  PrimaryButton,
  LocationAutocompleteInputField,
  FieldNumericStepper
} from '../../components';
import css from './styles.css';

const EditListingPresentationFormComponent = props => (
  <FinalForm
    {...props}
    mutators={{ ...arrayMutators }}
    render={fieldRenderProps => {
      const {
        className,
        disabled,
        handleSubmit,
        intl,
        invalid,
        pristine,
        saveActionMsg,
        updated,
        updateError,
        updateInProgress,
        values,
      } = fieldRenderProps;
      const locationLabel = intl.formatMessage({ id: 'EditListingPresentationForm.location.label' });
      const capacityTitle = intl.formatMessage({ id: 'EditListingPresentationForm.capacity.title' });
      const maxCapacityLabel = intl.formatMessage({ id: 'EditListingPresentationForm.maxCapacity.label' });
      const minCapacityLabel = intl.formatMessage({ id: 'EditListingPresentationForm.minCapacity.label' });
      const capacityErrorMessage = intl.formatMessage({ id: 'EditListingPresentationForm.capacity.error' });
      const locationPlaceholder = intl.formatMessage({ id: 'EditListingPresentationForm.location.placeholder' });
      const locationRequiredMessage = intl.formatMessage({ id: 'EditListingPresentationForm.location.required' });
      const locationErrorMessage = intl.formatMessage({ id: 'EditListingPresentationForm.location.error' });

      const errorMessage = updateError ? (
        <p className={css.error}>
          <FormattedMessage id='EditListingPresentationForm.updateFailed'/>
        </p>
      ) : null;

      const classes = classNames(css.root, className);
      const submitReady = updated && pristine;
      const submitInProgress = updateInProgress;
      const submitDisabled = invalid || disabled || submitInProgress;
      const { minCapacityToGuest, maxCapacityToGuest } = values;

      return (
        <Form className={classes} onSubmit={handleSubmit}>
          {errorMessage}
          <LocationAutocompleteInputField
            className={css.locationAddress}
            inputClassName={css.locationAutocompleteInput}
            iconClassName={css.locationAutocompleteInputIcon}
            predictionsClassName={css.predictionsRoot}
            validClassName={css.validLocation}
            name="location"
            label={locationLabel}
            placeholder={locationPlaceholder}
            useDefaultPredictions={false}
            format={null}
            valueFromForm={values.location}
            validate={composeValidators(
              autocompleteSearchRequired(locationRequiredMessage),
              autocompletePlaceSelected(locationErrorMessage),
            )}
          />
          <div className={css.capacityContainer}>
            <div className={css.capacityTitle}>
              {capacityTitle}
            </div>
            <FieldNumericStepper
              className={css.capacityItem}
              min={1}
              id="maxCapacityToGuest"
              name="maxCapacityToGuest"
              key={`maxCapacityToGuest_${minCapacityToGuest}`}
              label={maxCapacityLabel}
            />
            <FieldNumericStepper
              className={css.capacityItem}
              min={1}
              id="minCapacityToGuest"
              name="minCapacityToGuest"
              key={`minCapacityToGuest_${maxCapacityToGuest}`}
              label={minCapacityLabel}
              validate={composeValidators(
                numberOfMinimumCapacityMustBeInferiorToMaximumCapacity(capacityErrorMessage, maxCapacityToGuest),
              )}
            />
          </div>
          <div className={css.buttonContainer}>
            <PrimaryButton
              className={css.submitButton}
              type='submit'
              inProgress={submitInProgress}
              disabled={submitDisabled}
              ready={submitReady}
            >
              {saveActionMsg}
            </PrimaryButton>
          </div>
        </Form>
      );
    }}
  />
);

EditListingPresentationFormComponent.defaultProps = {
  className: null,
  updateError: null,
  initialValues: {},
};

EditListingPresentationFormComponent.propTypes = {
  className: string,
  onSubmit: func.isRequired,
  saveActionMsg: string.isRequired,
  updated: bool.isRequired,
  updateError: propTypes.error,
  updateInProgress: bool.isRequired,
  initialValues: object,

  // from injectIntl
  intl: intlShape.isRequired,
};

const Index = compose(injectIntl)(EditListingPresentationFormComponent);
Index.displayName = 'EditListingPresentationForm';

export default Index;



// WEBPACK FOOTER //
// ./src/forms/EditListingPresentationForm/index.js